import QRCode from 'qrcode'

/**
 * Render a URI (e.g. an otpauth:// TOTP provisioning URI) to an SVG data-URL
 * suitable for use as an `<img src>`.
 *
 * We deliberately use SVG (`QRCode.toString({type:'svg'})`) rather than
 * `toDataURL`/`toCanvas`. The qrcode library's browser build renders those via a
 * `<canvas>`, and that raster path produced a corrupt image (random colored
 * vertical stripes instead of the code) in the production build on some browsers.
 * SVG is vector, deterministic, bundler-agnostic, and bypasses the canvas + PNG
 * encoder entirely, so the code always renders correctly.
 *
 * The result is safe to drop straight into an `<img>` (no dangerouslySetInnerHTML);
 * `encodeURIComponent` escapes the `#` in the fill colors so the data URL is valid,
 * and the CSP allows `img-src data:`.
 */
export async function qrCodeSvgDataUrl(uri: string, width = 200): Promise<string> {
  const svg = await QRCode.toString(uri, { type: 'svg', margin: 2, width })
  return `data:image/svg+xml,${encodeURIComponent(svg)}`
}
